module.exports = __webpack_public_path__ + "img/data_safe.bb2cd6be.png";